











































import {Component, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {NavigationGuardNext, RawLocation} from 'vue-router'
import ContactBlock from '@/components/beta/Settings/ContactBlock.vue';
import Badges from '@/components/beta/Settings/Badges.vue';
import Products from '@/components/beta/Settings/Products/Products.vue';
import Profile from '@/components/beta/Settings/Profile.vue';
import EmailConfiguration from '@/components/beta/Settings/EmailConfiguration.vue';
import Surveys from '@/components/beta/Settings/Surveys.vue';
import Modal from '@/components/UI/Modal.vue';
import SurveyLimit from "@/components/beta/Settings/Surveys/SurveyLimit.vue";

const surveys = namespace('surveys')
const workspace = namespace('workspace')
const locale = namespace('locale')

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave'
])

@Component({
  components: {
    SurveyLimit,
    ContactBlock,
    Badges,
    Products,
    Profile,
    Surveys,
    Modal,
    EmailConfiguration,
  }
})
export default class Settings extends Vue {
  @workspace.Getter('getPlan') protected getPlan: any
  @surveys.Getter('isNotChange') protected isNotChange: any
  @surveys.Mutation('setIsNotChange') protected setIsNotChange: any
  @locale.Getter('getLocale') protected getLocale:any

  @Watch('$route', {immediate: true, deep: true})
  onParamsChange(newVal: any) {
   // alert(newVal.query.tab + ' wwwwww')
    if (!newVal.query.tab) return
    this.tab = newVal.query.tab
  }

  @Watch('getLocale')
  changeTabLocale() {
    (this.$refs.tabs as any).callSlider();
  }


  tab:string = 'contact-fields'
  isShowChange:boolean = false
  routeReserve: RawLocation | null = null

  beforeRouteLeave(to: RawLocation, from: RawLocation, next: NavigationGuardNext) {
    if (!this.isNotChange) {
      this.isShowChange = true
      this.routeReserve = to
    } else {
      next()
    }
  }

  mounted() {
    let searchParams = new URLSearchParams(document.location.search)
    this.tab = searchParams.get('tab') || 'contact-fields'
    window.scrollTo(0,0);
  }

  nextPage() {
    if (this.routeReserve) {
      this.setIsNotChange(true)
      this.isShowChange = false
      this.$router.push(this.routeReserve).catch(() => {})
    }
  }
  
  changeTab(tab:string) {
    // alert(1)
    // window.history.pushState('page2', 'Title', '?tab=' + tab)
    this.$router.replace({query:{tab:tab}}).catch(()=>{});
    // this.$route.query.tab=tab
  }

}
